module.exports = __webpack_public_path__ + "img/niigata.0d2aa579.png";